export default __webpack_public_path__ + "static/media/responsive-hoteleria.14700019.png";